import {
  createI18n,
  useI18n,
  type LocaleMessageValue,
  type VueMessageType,
} from "vue-i18n";
import { nl } from "vuetify/locale";
import { CurrencyType } from "@/application/enums";

type LocaleMessage = Record<string, LocaleMessageValue<VueMessageType>>;

const translations = import.meta.glob<LocaleMessage>(
  "@/**/translations/*.yaml",
  { eager: true, import: "default" },
);

const messages: Record<string, LocaleMessage> = {};

Object.entries(translations).forEach(([path, text]) => {
  const locale = path.match(/translations\/([\w-]+)\.yaml/)?.[1];

  if (!locale) return;

  messages[locale] = { ...(messages[locale] ?? {}), ...text };
});

const vuetifyTranslations = {
  nl,
};

const currencyFormatsNL: Record<string, Intl.NumberFormatOptions> = {};

Object.entries(CurrencyType).forEach((entries) => {
  currencyFormatsNL[entries?.[1]] = {
    style: "decimal",
    currency: entries?.[1],
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };
});

const numberFormats = {
  "nl-NL": currencyFormatsNL,
};

export default createI18n({
  legacy: false,
  locale: "nl-NL",
  messages,
  numberFormats,
});

export { useI18n, vuetifyTranslations };
